import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import styles from './Overlay.scss';

/**  Overlay is using absolute postion. Remember to set posiiton Reletive on the parent element */

const Overlay: React.FC = () => {
  const selectedPromotionPicker = useSelector(select.betSlip.selectedPromotionPicker);
  const isActive = Boolean(selectedPromotionPicker);

  return <>{isActive && <div data-testid="promotion-overlay" className={styles.overlay} />}</>;
};

export { Overlay };
